import { useContext } from 'react'
import { Navigate } from 'react-router-dom'
import { Spin } from 'antd'
import { AuthContext } from '@/contexts/AuthContext'
import { LANDING_CANDIDATES, LANDING_FALLBACK } from '@/config/landingRoutes'

export default function LandingRedirect() {
  const ctx = useContext(AuthContext)

  if (!ctx || !ctx.user || ctx.loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <Spin />
      </div>
    )
  }

  if (ctx.user.ruolo_id === 1) {
    return <Navigate to="/dashboard" replace />
  }

  const permSet = new Set(ctx.permissions)
  for (const candidate of LANDING_CANDIDATES) {
    if (candidate.permissions.some((p) => permSet.has(p))) {
      return <Navigate to={candidate.path} replace />
    }
  }

  return <Navigate to={LANDING_FALLBACK} replace />
}
